// Campos básicos de lead frio editáveis como célula (grade e painel lateral):
// tipo de coluna → editor/validação do ProspectCell.
import type { ProspectFieldDef } from "@/lib/prospectFields";

export type CoreCellKey =
  | "name"
  | "contact_name"
  | "phone"
  | "email"
  | "website"
  | "instagram"
  | "city"
  | "state"
  | "notes";

export const CORE_CELL_FIELDS: (Pick<ProspectFieldDef, "type" | "options" | "label"> & {
  key: CoreCellKey;
})[] = [
  { key: "name", label: "Nome", type: "text", options: [] },
  { key: "contact_name", label: "Contato", type: "text", options: [] },
  { key: "phone", label: "Telefone", type: "phone", options: [] },
  { key: "email", label: "E-mail", type: "email", options: [] },
  { key: "website", label: "Site", type: "url", options: [] },
  { key: "instagram", label: "Instagram", type: "url", options: [] },
  { key: "city", label: "Cidade", type: "text", options: [] },
  { key: "state", label: "UF", type: "text", options: [] },
  { key: "notes", label: "Observações", type: "long_text", options: [] },
];
